import { Link, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function Navbar() {
  const navigate = useNavigate();
  const { lang, setLang, t } = useLang();

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#0B1020]/70 border-b border-white/5"
      data-testid="main-navbar"
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <Sparkles className="w-5 h-5" style={{ color: "#D4AF37" }} strokeWidth={1.5} />
          <span className="font-serif text-2xl tracking-wide text-white">
            {lang === "hi" ? (
              <>मंत्रणा<span className="gold-text"> One</span></>
            ) : (
            <>Mantrana<span className="gold-text"> One</span></>
            )}
          </span>
        </Link>
        <div className="hidden md:flex items-center gap-10 text-sm text-slate-300">
          <a href="/#features" className="hover:text-white transition" data-testid="nav-how-it-works">
            {t("nav.howItWorks")}
          </a>
          <a href="/#pricing" className="hover:text-white transition" data-testid="nav-pricing">
            {t("nav.pricing")}
          </a>
        </div>
        <div className="flex items-center gap-3">
          {/* Language toggle — persistent */}
          <div
            className="hidden sm:flex items-center rounded-full border border-white/10 overflow-hidden text-[11px] tracking-wide"
            data-testid="nav-lang-toggle"
          >
            <button
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition ${
                lang === "en" ? "bg-[#D4AF37] text-[#0B1020]" : "text-slate-300 hover:bg-white/5"
              }`}
              data-testid="nav-lang-en"
            >
              EN
            </button>
            <button
              onClick={() => setLang("hi")}
              className={`px-3 py-1.5 transition font-serif ${
                lang === "hi" ? "bg-[#D4AF37] text-[#0B1020]" : "text-slate-300 hover:bg-white/5"
              }`}
              data-testid="nav-lang-hi"
            >
              हि
            </button>
          </div>
          <button
            onClick={() => navigate("/language")}
            className="rounded-full px-5 py-2 text-sm font-medium transition-colors"
            style={{ background: "#D4AF37", color: "#0B1020" }}
            data-testid="nav-start-button"
          >
            {t("nav.startReading")}
          </button>
        </div>
      </nav>
    </header>
  );
}
